// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__Uk1oV","arrow":"Tooltip_arrow__N4OTi"};